module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-cyrillic-ext-700-normal.woff2?be4d02458ce53887dc3729735f37b7ae";